import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "post",
  makeRequestUrl: (host,isFeature, project) => {
    return `${host}/cp/${project}/client_portal_feedback?OPERATION=${isFeature}`
  },
  checkRequiredArguments: (changeRequestData) => {
    if (changeRequestData === undefined) throw new Error("No change request data supplied.")
  },
  makeResponseData: (json) => {
    return json
  },
  returnRawResponse: true
}
export default createFetcher(fetcherConfiguration)
